import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'samples-retailer_sample_request_button_web-view';

/**
 * Fire event when the retailer views the CTA that opens up the sample request modal.

The source has been updated to be the following: BRAND_PAGE_BANNER, PDP_BANNER , or PDP_BUY_BOX 
 */
export function trackSamplesRetailerSampleRequestButtonWebView(
  source_PDP_or_BRAND: string,
  brandToken: string,
  productToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { source_PDP_or_BRAND, brandToken, productToken },
  });
}
